import * as types from './types';
import { ODOM_STATUS_TYPE, decodeFrom } from '../../../utils/config';

const initialState = {
  dataSaving: null,
  isOdomDecode: false,
  checkingOdom: false,
  isManualOdomCustom: decodeFrom.ORTHER,
  odomStatus: ODOM_STATUS_TYPE.ODOM_DEFAULT,
};

const odomReducer = (state = initialState, action) => {
  const type = action.type;
  const payload = action.payload;
  switch (type) {
    case types.SHOW_ODOM: {
      return {
        ...state,
        isOdomDecode: true,
        isManualOdomCustom: payload,
      };
    }
    case types.CHECKING_ODOM: {
      return {
        ...state,
        isOdomDecode: false,
        odomStatus: payload.status,
      };
    }
    case types.HIDE_ODOM: {
      return {
        ...state,
        isOdomDecode: false,
        isManualOdomCustom: decodeFrom.ORTHER,
      };
    }
    case types.SAVING_DATA: {
      return {
        ...state,
        dataSaving: payload.data,
      };
    }
    case types.CHECK_ODOM: {
      return {
        ...state,
        checkingOdom: true,
      };
    }
    case types.RESET_ODOM: {
      return initialState;
    }
    default:
      return state;
  }
};
export default odomReducer;
